import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const Confetti = React.memo(() => {
  const confettiPieces = useMemo(() => {
    const pieces = [];
    const colors = [
      'bg-sky-400', 'bg-purple-500', 'bg-orange-500', 'bg-red-800',
      'bg-lime-400', 'bg-red-500', 'bg-yellow-400', 'bg-blue-800',
      'bg-green-500', 'bg-pink-400'
    ];
    const numPieces = 150;

    for (let i = 0; i < numPieces; i++) {
      pieces.push({
        id: i,
        color: colors[Math.floor(Math.random() * colors.length)],
        left: `${Math.random() * 100}%`,
        duration: Math.random() * 3 + 2, // 2 to 5 seconds
        delay: Math.random() * 4,
        rotate: Math.random() * 360,
        endX: Math.random() * 200 - 100, // drift left or right
      });
    }
    return pieces;
  }, []);

  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-[2000]">
      {confettiPieces.map(({ id, color, left, duration, delay, rotate, endX }) => (
        <motion.div
          key={id}
          className={`absolute w-2 h-4 ${color} rounded-sm shadow-lg`}
          style={{ top: '-20px', left }}
          initial={{ opacity: 1, scale: 1 }}
          animate={{
            y: '100vh',
            x: endX,
            rotate: rotate + 180,
            opacity: 0,
            scale: 0.5,
          }}
          transition={{
            duration,
            delay,
            ease: 'easeOut',
          }}
        />
      ))}
    </div>
  );
});

export default Confetti;
